export const CHANGE_TEMPLATE = 'CHANGE_TEMPLATE';
export const CHANGE_PAGE_SIZE = 'CHANGE_PAGE_SIZE';

export const changeTemplate = payload => ({ type: CHANGE_TEMPLATE, payload: payload });
export const changePageSize = payload => ({ type: CHANGE_PAGE_SIZE, payload: payload });
